import { GET } from 'utils/requests.utils'

const BASE_URL_V1S1 = '/v1.1/cabinet/orders'

export const createOrdersApi = () => ({
  fetchList: (params) => GET(BASE_URL_V1S1, params),
})

export type OrdersApi = ReturnType<typeof createOrdersApi>
